import React, {useState} from 'react';
import '../../App.scss';
import { updateState, loadingStart, loadingComplete, upsertStateIn} from "../StateHelper";
import {resolveEnum, WAREHOUSE_STOCK_TYPES, UNIT_TYPES, IMPORT_OPTIONS, EXPORT_OPTIONS} from '../../Constants';
import {Button, Table, Modal, ToggleButton} from 'react-bootstrap'
import AuthorizedPage from '../../component/AuthorizedPage';
import ProductItemApi from '../../api/ProductItemApi';
import QuickFilterButton from '../../component/QuickFilterButton';
import { Role } from '../../domain/Role';

const initialState = {
  productItemsRaw:new Array(),
  productItems:new Array(),
  showProductItemStockUpdateModal:false,
  showProductItemImportExportModal:false,
  selectedProductItem:new Object(),
  stockOperationType: new Object(),
  packagingGroups: new Array(),
  warehouseStockType: new Array(),
  warehouses: new Array(),
  selectedPackagingGroup: "",
  selectedWarehouseStockType: "",
  selectedWarehouse: "",
  selectedStockOperationType: "",
  selectedStockOperationTypeError: false,
  description: "",
  page: 0,
  totalPages: 0,
  search: "",
  pageSize: 50,
};

const PAGE_SIZE_OPTIONS = [20, 50, 100, 200];

class StockImportExportPersonal extends React.Component<any,any> {
  searchTimer: any;

  constructor(props: any) {
    super(props);
    this.state = initialState;
    this.onSubmit = this.onSubmit.bind(this);
    this.renderProductItemStockUpdateModal = this.renderProductItemStockUpdateModal.bind(this);
    this.renderProductImportExportModal = this.renderProductImportExportModal.bind(this);
    this.renderStockTable = this.renderStockTable.bind(this);
    this.renderStockProductItemImportExportTable = this.renderStockProductItemImportExportTable.bind(this);
    this.renderStockHistoryTable = this.renderStockHistoryTable.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
     this.init();
     this.loadPackagingGroups();
     this.loadWarehouseStockTypes();
     this.loadWarehouses();
  }

  init() {
    this.loadProductItems("","","");
  }

  refresh() {
    this.setState(initialState);
    this.init();
  }

  async loadProductItems(packagingGroup:any, warehouseStockType:any, warehouse: any, page:number = this.state.page, search:string = this.state.search) {
    loadingStart(this);
    let response = await ProductItemApi.listFilteredPaged(packagingGroup, warehouseStockType, warehouse, false, search, page, this.state.pageSize);
     if(response.success && response.data) {
       updateState(this, "productItems", response.data.content || []);
       this.setState({ totalPages: response.data.totalPages || 0, page: response.data.number || 0 });
     }
     loadingComplete(this);
  }

  gotoPage = (page:number, searchOverride?:string) => {
    const search = searchOverride !== undefined ? searchOverride : this.state.search;
    const type = this.state.selectedWarehouseStockType === "Tümü" ? "" : this.state.selectedWarehouseStockType;
    const warehouse = this.state.selectedWarehouse === "Tümü" ? "" : this.state.selectedWarehouse;
    this.loadProductItems(this.state.selectedPackagingGroup, type, warehouse, page, search);
  };

  onSearchChange = (value:string) => {
    this.setState({ search: value });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.gotoPage(0, value), 350);
  };

  onPageSizeChange = (size:number) => {
    this.setState({ pageSize: size }, () => this.gotoPage(0));
  };

  renderPagination = () => {
    const { page, totalPages, pageSize } = this.state;
    return (
      <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
        <Button size="sm" variant="outline-secondary" className="me-3" disabled={page <= 0} onClick={() => this.gotoPage(page - 1)}>← Önceki</Button>
        <span>Sayfa {totalPages === 0 ? 0 : page + 1} / {totalPages}</span>
        <Button size="sm" variant="outline-secondary" className="ms-3" disabled={page >= totalPages - 1} onClick={() => this.gotoPage(page + 1)}>Sonraki →</Button>
        <select
          className="form-select form-select-sm ms-4"
          style={{ width: "auto" }}
          value={pageSize}
          onChange={(e) => this.onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((n) => (
            <option key={n} value={n}>{n} / sayfa</option>
          ))}
        </select>
      </div>
    );
  };

  onModalClose(newItem?:any) {
    updateState(this, "showProductItemStockUpdateModal", false);
    updateState(this, "showProductItemImportExportModal", false);
    updateState(this, "selectedProductItem", new Object());
    updateState(this, "selectedStockOperationType", "");
    updateState(this, "selectedStockOperationTypeError", false);
    updateState(this, "description", "");

    if(newItem) {
      upsertStateIn(this, "productItemsRaw", newItem);
      upsertStateIn(this, "productItems", newItem);
    }
  }

  async loadPackagingGroups() {
    let response = await ProductItemApi.listPackagingGroups();
    if(response.success) {
      updateState(this, "packagingGroups", response.data);
    }
  }

  async loadWarehouseStockTypes() {
      let response = await ProductItemApi.listWarehouseStockTypes();
      if (response.success) {
          // Backend’den gelenler yerine sabit enum değerlerini kullanıyoruz
          const typesWithAll = ["Tümü", ...WAREHOUSE_STOCK_TYPES.map(type => type.value)];
          updateState(this, "warehouseStockTypes", typesWithAll);
      }
  }

   async loadWarehouses() {
        let response = await ProductItemApi.listWarehouses();
         if (response.success) {
                   // Backend’den gelenler yerine sabit enum değerlerini kullanıyoruz
                   const typesWithAll = ["Tümü", ...response.data];
                   updateState(this, "warehouses", typesWithAll);
               }
    }

  async onSubmit(e:any) {
      e.preventDefault();
      const formData = new FormData(e.target);
      const formObject = Object.fromEntries(formData);

      let hasError = false;

      if (!formObject.stockOperationType) {
        updateState(this, "selectedStockOperationTypeError", true);
        hasError = true;
      } else {
        updateState(this, "selectedStockOperationTypeError", false);
      }

      const descriptionValue = formObject.description;
      const descriptionString = typeof descriptionValue === "string" ? descriptionValue : "";

      if(hasError) return;

      let enrties = Object.entries(formObject).map((item:any) => ({key:item[0], value:item[1]}));
      this.onProductItemStockOperation(enrties, formObject.stockOperationType, descriptionString);
  }

  async onProductItemStockOperation(stockSet:any, stockOperationType:any, notes?: string) {
    var normalizedStockChangesSet = stockSet.filter((s:any) => s.key != "stockOperationType" && s.key != "description");
    let normalizedType = stockOperationType;
    if (
      [
        "PRODUCTION_INBOUND",
        "RETURN_INBOUND",
        "CONSIGNMENT_INBOUND",
        "TRANSFER_INBOUND",
        "PURCHASE_INBOUND",
      ].includes(stockOperationType)
    ) {
      normalizedType = "import";
    } else if (
      [
        "SHIPMENT_OUTBOUND",
        "RETAIL_OUTBOUND",
        "INDIVIDUAL_OUTBOUND",
        "TRANSFER_OUTBOUND",
        "BRANCH_OUTBOUND",
        "SALES_REP_OUTBOUND",
        "REWORK_OUTBOUND",
        "PACKAGING_OUTBOUND",
        "FACTORY_SALES_POINT_OUTBOUND",
      ].includes(stockOperationType)
    ) {
      normalizedType = "export";
    }


    if("import" == normalizedType) {
      let requestItems = normalizedStockChangesSet
      .map((s:any) => {
        return {id:s.key, importedQuantity:s.value, stockOperationType:stockOperationType, notes};
      });
      let requestDTO = {stockChange:requestItems};
      let response = await ProductItemApi.stockImportBulk(requestDTO);
      if(response.success) {
        this.onModalClose(response.data);
      }
    }

    if("export" == normalizedType) {
      let requestItems = normalizedStockChangesSet
      .map((s:any) => {
        return {id:s.key, exportedQuantity:s.value, stockOperationType:stockOperationType, notes};
      });
      let requestDTO = {stockChange:requestItems};

      let response = await ProductItemApi.stockExportBulk(requestDTO);
      if(response.success) {
        this.onModalClose(response.data);
      }
    }

    if("update" == normalizedType) {
      let requestItems = normalizedStockChangesSet
      .map((s:any) => {
        return {id:s.key, quantity:s.value, notes};
      });
      let requestDTO = {updatedStocks:requestItems}
      let response = await ProductItemApi.updateProductItemPoolStockBulk(requestDTO);
      if(response.success) {
        this.onModalClose(response.data);
      }
    }
  }

  updateProducPoolItemInfo(selected:any) {
    updateState(this,"stockOperationType", "update");
    updateState(this,"selectedProductItem", selected);
    updateState(this,"showProductItemStockUpdateModal", true);
  }

  doStockImport(selected:any) {
     updateState(this, "stockOperationType", "import");
     updateState(this, "selectedProductItem", selected);
     updateState(this, "selectedStockOperationType", "");
     updateState(this, "showProductItemImportExportModal", true);
   }

  doStockExport(selected:any) {
     updateState(this, "stockOperationType", "export");
     updateState(this, "selectedProductItem", selected);
     updateState(this, "selectedStockOperationType", "");
     updateState(this, "showProductItemImportExportModal", true);
  }

  onSearch(filteredItems:any) {
    updateState(this, "productItems", filteredItems);
  }

  async onPackagingGroupChange(selectedGroup:any) {
    updateState(this, "selectedPackagingGroup", selectedGroup);
    this.loadProductItems(selectedGroup, this.state.selectedWarehouseStockType, this.state.selectedWarehouse, 0);
  }

  async onWarehouseStockTypeChange(selectedType: string) {
      selectedType = WAREHOUSE_STOCK_TYPES.find(item => item.value === selectedType)?.key || "";

      updateState(this, "selectedWarehouseStockType", selectedType);

      const backendValue = selectedType === "Tümü" ? "" : selectedType;
      this.loadProductItems(this.state.selectedPackagingGroup, backendValue, this.state.selectedWarehouse, 0);
  }

  async onWarehouseChange(selectedWarehouse: string) {
      updateState(this, "selectedWarehouse", selectedWarehouse);
      const backendValue = selectedWarehouse === "Tümü" ? "" : selectedWarehouse;
      this.loadProductItems(this.state.selectedPackagingGroup, this.state.selectedWarehouseStockType, backendValue, 0);
  }

  renderStockHistoryTable = () => {
    const rows = this.state.stockHistoryData && this.state.stockHistoryData.map((item:any) =>
                <tr key={item.id}>
                  <td>{item.action.label} {item.orderId && '#('+item.orderId+')'}</td>
                  <td>{item.quantityChange}</td>
                  <td>{item.quantityAfterChange - item.quantityChange} to {item.quantityAfterChange}</td>
                  <td>{item.wareHouse.label}</td>
                  <td>{item.createdAt}</td>
                </tr>);

    return <Table  striped bordered hover>
            <thead>
              <tr>
                <th>Aksiyon</th>
                <th>Değişen Miktar</th>
                <th>Değişim</th>
                <th>Depo</th>
                <th>Tarih</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>;
  };

  renderStockHistoryModal = () => {
    return <Modal size="lg" autoFocus={true} show={this.state.showStockHistoryModal} onHide={() => updateState(this, "showStockHistoryModal", false)} dialogClassName="modal-70w">
            <Modal.Header closeButton>
              <Modal.Title>Stok Hareketleri</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {this.renderStockHistoryTable()}
            </Modal.Body>
          </Modal>;
  }

  renderProductItemTable = () => {
      return <Table  striped bordered hover>
              <thead>
                <tr>
                  <th>Ürün Adı / Stok Kodu</th>
                  <th>Barcode</th>
                  <th>Stoklama Şekli</th>
                  <th>Giriş</th>
                  <th>Çıkış</th>
                </tr>
              </thead>
              <tbody>
                {this.renderProductItemTableRows(this.state.productItems)}
              </tbody>
            </Table>;
  };

  renderProductItemTableRows = (productItems: any) => {
    return productItems && productItems.map((it: any) => {
      return (
        <tr key={it.id}>
          <td>
            <div style={{ fontSize: "10px", color: "#888" }}>{it.stockCode}</div> {/* Küçük ve gri */}
            <div style={{ fontSize: "12px", fontWeight: "400" }}>{it.name}</div> {/* Büyük ve kalın */}
          </td>
          <td>{it.barcode}</td>
          <td>{it.packagingUnitTypeAmount} {resolveEnum(it.packagingUnitType)} {resolveEnum(it.packagingType)}</td>
          <td>
            <Button size="sm" variant="outline-success" onClick={() => this.doStockImport(it)}>
              Mal Girişi
            </Button>
          </td>
          <td>
            <Button size="sm" variant="outline-warning" onClick={() => this.doStockExport(it)}>
              Mal Çıkışı
            </Button>
          </td>
        </tr>
      );
    });
  };


  renderStockTable = (stocks:any) => {
      return <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Depo</th>
                  <th>Stoklama Şekli</th>
                  <th>Sayım ile Düzeltilmiş Yeni Adet</th>
                </tr>
              </thead>
              <tbody>
                {this.renderStockRows(stocks)}
              </tbody>
            </Table>;
  };

  renderStockProductItemImportExportTable = (stocks:any, stockOperationType:any) => {
    var importExportLabel = "";
    if("import" == stockOperationType) importExportLabel = "Gelen Adet";
    if("export" == stockOperationType) importExportLabel = "Çıkan Adet";
    if("update" == stockOperationType) importExportLabel = "Güncel Düzeltilmiş Yeni Adet";

    return <Table striped bordered hover>
            <thead>
              <tr>
                <th>Depo</th>
                <th>Stoklama Şekli</th>
                <th>{importExportLabel}</th>
              </tr>
            </thead>
            <tbody>
              {this.renderImportExportStockRows(stocks)}
            </tbody>
          </Table>;
  };

  renderStockRows = (stocks:any) => {
    return stocks && stocks.map((it:any) => {
        return (<tr key={it.id}>
                <td>{`DEPO-${it.warehouseId ?? 'Unknown'}`}</td>
                <td>{it.packagingUnitTypeAmount} {resolveEnum(it.packagingUnitType)} {resolveEnum(it.packagingType)}</td>
                <td>{it.quantity}
                  <br/>
                  {'[ ' + it.boxQuantity + ' Koli ]'}
                </td>
                <td><input type="text" style={{width:"50px"}} defaultValue={it.quantity || 0} name={it.id}></input></td>
              </tr>)
    });
  };

  renderImportExportStockRows = (stocks:any) => {
    return stocks && stocks.map((it:any) => {
      return <tr key={it.id}>
              <td>{`DEPO-${it.warehouseId ?? 'Unknown'}`}</td>
              <td>{it.packagingUnitTypeAmount} {resolveEnum(it.packagingUnitType)} {resolveEnum(it.packagingType)}</td>
              <td><input type="text" style={{width:"50px"}} name={it.id} defaultValue={0}></input></td>
            </tr>
    });
  };

  renderProductItemStockUpdateModal = () => {
    let {id, stocks} = this.state.selectedProductItem || new Object();
    let stockTable = <span></span>;

    if(id) {
       stockTable = this.renderStockTable(stocks);
    }

    let warningMessage = "Mal sayım sonrası girilen adetler mevcut stokları günceller. Emin olmadığınız stoklar için giriş yapmayınız!"
    var stockOperationType = this.state.stockOperationType;

    return <Modal size="lg" autoFocus={true} show={this.state.showProductItemStockUpdateModal} onHide={() => this.onModalClose()} dialogClassName="modal-90w">
            <Modal.Header closeButton>
              <Modal.Title>Mal Sayım Stok Düzenleme</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="row">
              <p style={{color:'red'}}>
                {warningMessage}
              </p>
            </div>
              <form onSubmit={this.onSubmit}>
                <div className="row">
                    {stockTable}
                </div>
                <div className="row">
                <input type="hidden" name="stockOperationType" value={stockOperationType}></input>
                <Button type="submit" value="Submit" variant="outline-success">Değişikliği Uygula</Button>
                </div>
                </form>
            </Modal.Body>
          </Modal>
  };

 renderProductImportExportModal = () => {
   if (!this.state.selectedProductItem) return null;

   let { id, stocks, stockCode, name } = this.state.selectedProductItem || new Object();
   let stockTable = id ? this.renderStockProductItemImportExportTable(stocks, this.state.stockOperationType) : <span></span>;

   const stockOperationType = this.state.stockOperationType;
   let stockOperationHeaderLabel = "";
   let warningMessage = "";

   if (stockOperationType === "import") {
     stockOperationHeaderLabel = `Mal Girişi (${stockCode} - ${name})`;
     warningMessage = "Girilen adetler mevcut stokların üzerine eklenir!";
   }
   if (stockOperationType === "export") {
     stockOperationHeaderLabel = `Mal Çıkışı (${stockCode} - ${name})`;
     warningMessage = "Girilen adetler mevcut stoklardan düşer!";
   }
   if (stockOperationType === "update") stockOperationHeaderLabel = "Stok Güncelle";

   const stockOptions = stockOperationType === "import" ? IMPORT_OPTIONS : EXPORT_OPTIONS;

   return (
     <Modal
       size="lg"
       autoFocus={true}
       show={this.state.showProductItemImportExportModal}
       onHide={() => this.onModalClose()}
       dialogClassName="modal-90w"
     >
       <Modal.Header closeButton>
         <Modal.Title>{stockOperationHeaderLabel}</Modal.Title>
       </Modal.Header>

       <Modal.Body>
         <div className="row">
           <p style={{ color: "red" }}>{warningMessage}</p>
         </div>

         <form onSubmit={this.onSubmit}>
           {/* Stok Hareket Tipi */}
           <div className="row mb-3">
             <label>Stok Hareket Tipi:</label>
             <div className="stock-toggle-container">
               {stockOptions.map((option) => (
                 <ToggleButton
                   key={option.value}
                   id={`mgmt-radio-${option.value}`} // EKLENDİ: Benzersiz ID
                   type="radio"
                   name="stockOperationType"
                   value={option.value}
                   checked={this.state.selectedStockOperationType === option.value}
                   onClick={() => updateState(this, "selectedStockOperationType", option.value)}
                   className={`stock-toggle-button ${
                     this.state.selectedStockOperationType === option.value ? "selected" : ""
                   }`}
                   variant="outline-primary"
                 >
                   {option.label}
                 </ToggleButton>
               ))}
             </div>
             {this.state.selectedStockOperationTypeError && (
               <div className="invalid-feedback d-block">Lütfen işlem tipini seçiniz.</div>
             )}
           </div>

           {/* Stok Tablosu */}
           <div className="row mb-3">{stockTable}</div>

           {/* Açıklama */}
           <div className="row mb-3">
             <label>Açıklama:</label>
             <textarea
               name="description"
               style={{ width: "100%", minHeight: "80px" }}
               value={this.state.description || ""}
               onChange={(e) => updateState(this, "description", e.target.value)}
             />
           </div>

           {/* Submit */}
           <div className="row">
             <Button type="submit" value="Submit" variant="outline-success">
               Değişikliği Uygula
             </Button>
           </div>
         </form>
       </Modal.Body>
     </Modal>
   );
 };


  render() {
    return <AuthorizedPage roles={[Role.WAREHOUSE_STAFF]}>
            <div className="container-fluid">
              <h4>Mal Giriş Çıkış Yönetimi</h4>
              <div className="search-container">
                <input
                  type="text"
                  placeholder="Ara"
                  value={this.state.search}
                  onChange={(e) => this.onSearchChange(e.target.value)}
                  className="search-input"
                />
                <div className="search-icon"></div>
              </div>
              <div className="row" style={{marginBottom:"10px"}}>
                                          <QuickFilterButton selected = {this.state.selectedWarehouseStockTypes} onSelect={(event:any) => this.onWarehouseStockTypeChange(event)} items={this.state.warehouseStockTypes} />
                                    </div>
              <div className="row" style={{marginBottom:"10px"}}>
                                                    <QuickFilterButton selected = {this.state.selectedWarehouse} onSelect={(event:any) => this.onWarehouseChange(event)} items={this.state.warehouses} />
                                                  </div>
              <div className="row" style={{marginBottom:"10px"}}>
                        <QuickFilterButton selected = {this.state.selectedPackagingGroup} onSelect={(event:any) => this.onPackagingGroupChange(event)} items={this.state.packagingGroups} />
                      </div>
              {this.renderProductItemTable()}
              {this.renderPagination()}
              {this.renderProductItemStockUpdateModal()}
              {this.renderProductImportExportModal()}
            </div>
          </AuthorizedPage>
  }
}

export default StockImportExportPersonal;
